var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3999 10.8H3.5999C2.93716 10.8 2.3999 11.3373 2.3999 12C2.3999 12.6628 2.93716 13.2 3.5999 13.2L20.3999 13.2C21.0626 13.2 21.5999 12.6628 21.5999 12C21.5999 11.3373 21.0626 10.8 20.3999 10.8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3999 16.8H3.5999C2.93716 16.8 2.3999 17.3373 2.3999 18C2.3999 18.6628 2.93716 19.2 3.5999 19.2H20.3999C21.0626 19.2 21.5999 18.6628 21.5999 18C21.5999 17.3373 21.0626 16.8 20.3999 16.8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3999 4.80001L3.5999 4.80001C2.93716 4.80001 2.3999 5.33727 2.3999 6.00001C2.3999 6.66275 2.93716 7.20001 3.5999 7.20001L14.3999 7.20001C15.0626 7.20001 15.5999 6.66275 15.5999 6.00001C15.5999 5.33727 15.0626 4.80001 14.3999 4.80001Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.41240e75c72d0f58155aada2310e3d3f.svg";
export { ForwardRef as ReactComponent };